export default __webpack_public_path__ + "static/media/ecoute.14f775a7.png";